import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid,
  Tooltip, ResponsiveContainer, Legend
} from 'recharts';
import { TrendingDown } from 'lucide-react';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload) return null;
  return (
    <div className="p-2 rounded-lg bg-[var(--nexus-bg-surface)] border border-[var(--nexus-border)] shadow-lg">
      <p className="font-mono text-[10px] text-[var(--nexus-text-muted)] mb-1">{label}</p>
      {payload.map((p, i) => (
        <div key={i} className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full" style={{ backgroundColor: p.color }}></span>
          <span className="text-[10px] text-[var(--nexus-text-secondary)]">{p.name}:</span>
          <span className="font-mono text-[10px] text-[var(--nexus-text-primary)] tabular-nums">{p.value} min</span>
        </div>
      ))}
    </div>
  );
};

export const MttrChart = ({ data }) => {
  return (
    <div data-testid="mttr-chart" className="nexus-card relative overflow-hidden">
      <div className="p-3 border-b border-[var(--nexus-border)]">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <TrendingDown size={14} className="text-[var(--nexus-success)]" />
            <h2 className="text-sm font-semibold text-[var(--nexus-text-primary)] tracking-wide">MTTR Trend</h2>
          </div>
          <span className="text-[10px] text-[var(--nexus-text-muted)]">Last 30 days (minutes)</span>
        </div>
      </div>
      <div className="p-3">
        <ResponsiveContainer width="100%" height={200}>
          <AreaChart data={data} margin={{ top: 5, right: 5, left: -10, bottom: 0 }}>
            <defs>
              <linearGradient id="gradP1" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#EF4444" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#EF4444" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="gradP2" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#F59E0B" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#F59E0B" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="gradP3" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#6366F1" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#6366F1" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(148,163,184,0.08)" />
            <XAxis
              dataKey="date"
              tick={{ fontSize: 10, fill: '#475569', fontFamily: 'JetBrains Mono' }}
              axisLine={{ stroke: '#1E2A45' }}
              tickLine={{ stroke: '#1E2A45' }}
              interval={6}
            />
            <YAxis
              tick={{ fontSize: 10, fill: '#475569', fontFamily: 'JetBrains Mono' }}
              axisLine={{ stroke: '#1E2A45' }}
              tickLine={{ stroke: '#1E2A45' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend
              verticalAlign="top"
              height={24}
              wrapperStyle={{ fontSize: '10px', fontFamily: 'JetBrains Mono' }}
            />
            <Area
              type="monotone" dataKey="p1" name="P1" stroke="#EF4444" fill="url(#gradP1)" strokeWidth={1.5}
            />
            <Area
              type="monotone" dataKey="p2" name="P2" stroke="#F59E0B" fill="url(#gradP2)" strokeWidth={1.5}
            />
            <Area
              type="monotone" dataKey="p3" name="P3" stroke="#6366F1" fill="url(#gradP3)" strokeWidth={1.5}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
